export default
{
    components:
    {

    },

    props:
    {
        content: { type: Object, default: null }
    },

    mounted()
    {
        this.$emit('page:ready')
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-cms/script.js